import { BaseRequestModel } from "./BaseModel/BaseRequestModel";
import { PaginationModel } from "./pagination-model";

export class ActiveBlackListedRequestModel extends BaseRequestModel{
    pagination:PaginationModel;
}
